import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import Selectsearch from "react-select";
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import {
	FormGroup,
	Label,
	
} from 'reactstrap';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';
import ProgressLoader from 'Components/Widgets/ProgressLoader';

import { 
    allStudents,
    allClubs,
    addOCScoring,
 } from 'Actions';

 import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

class AddItems extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,
    };

    UNSAFE_componentWillMount() {
        this.props.allStudents();
        this.props.allClubs();
	}
    constructor(props) {
      
        super(props);
        this.state = {  
            seldate:new Date(),
            student:this.props.data.student, 
            club:'',
            loader:false,
            sepmore:1,
            chkcount:0,
            formValues: [{ holepar : "", fwhit : "", distance : "", girhit : "", puttlength:"", noputt : "", penalties : "", score : "", process : ""}],
            editable: {},
            errors: {}
        };
    }

    validateForm = () => {
        const errors = {};
        let isValid = true;

        if (!this.state.student) {
            errors.student = 'Please select a student';
            isValid = false;
        }

        if (!this.state.club) {
            errors.club = 'Please select a course';
            isValid = false;
        }

        this.setState({ errors });
        return isValid;
    }

    selstudent = (evt) =>{
        var stdid =evt.value;
        this.setState({ student:stdid });
    }

    selclub = (evt) =>{
        var clubid =evt.value;
        this.setState({ club:clubid });
    }

    selectdate = (date) => {
        const seldate =moment(new Date(date)).format('yyyy-MM-DD');
        this.setState({ seldate:date });
        
    }    

    addHandleSubmit(event){
        event.preventDefault();
        
        var sepmore=this.state.sepmore;
        if (this.validateForm()) {
            this.setState({ loader:true });
            this.props.addOCScoring(event, sepmore).then((data) => {   
            
                if(data.status==1){                    
                    this.setState({ 
                        loader:false,
                        student:'',
                        seldate:'',
                        club:'',
                    });

                    document.getElementById("addform").reset();  
                    
                    setTimeout(() => {
                        this.props.onClick();
                    }, 2000);
                }
            });
        }
        
    }
    
    addFormFields() {
        var chktotal=this.state.sepmore;
        var totalsep=chktotal+1;
        this.setState(({
          sepmore:totalsep,  
          formValues: [...this.state.formValues, { holepar : "", fwhit : "", distance : "", girhit : "", puttlength:"", noputt : "", penalties : "", score : "", process : ""}]
        }))
    }
    
    removeFormFields(i) {
        let formValues = this.state.formValues;
        var chktotal=this.state.sepmore;
        var totalsep=chktotal-1;
        formValues.splice(i, 1);
        this.setState({ formValues, sepmore:totalsep });
    }

    handleChange(i, e) {
        var selname=e.target.name;
        var inputval=e.target.value;
        if(selname=='holepar'&&inputval==3){
            var chkdis=this.state.editable['fwhit_'+i];
            if(chkdis==false||chkdis==undefined){
                let setForm = this.state.formValues;
                setForm[i]['fwhit'] = ''; 
                this.setState({ setForm });
                this.setState(({ editable }) => ({                    
                    editable: { ...editable, ['fwhit_'+i]: !editable['fwhit_'+i] }
                }));
            }
        }else{
            var chkdis=this.state.editable['fwhit_'+i];
            if(chkdis==true){            
                this.setState(({ editable }) => ({                    
                    editable: { ...editable, ['fwhit_'+i]: !editable['fwhit_'+i] }
                }));
            }
        }
        
        let formValues = this.state.formValues;        
        formValues[i][e.target.name] = e.target.value; 
        this.setState({ formValues });            

    }

    handleNumberic(e) {               
        if (!/[0-9,.]/.test(e.key)) {
            e.preventDefault();
        } 
    }

    handleChangeRadio(val, e, frm){

        let formValues = this.state.formValues;
        var radval=e.target.value;
        if(frm==1){
            formValues[val]['penalties'] = radval; 
            this.setState({ formValues });
        }else{
            formValues[val]['process'] = radval; 
            this.setState({ formValues });
        }
    }


render() {

    const { studentlists, clublist, loading} = this.props;   
    const allstudent=studentlists.map((stdval) => {  
        return {
           label: stdval.student,  
           value: stdval.uudID
        }
    });
    
    const allclub=clublist.map((stdval) => {  
        return {
           label: stdval.ccb_clubName,  
           value: stdval.ccb_clubID
        }
    });

    const stdrole=localStorage.getItem('stdrole');
      return(
        <div>
            <div className="col-lg-12">
                <form autoComplete="off" id="addform" onSubmit={(e)=>this.addHandleSubmit(e)}>
                     <div className="row">
                        <div className="col-sm-12 col-lg-12" style={{margin:"0 auto"}}>
                            <RctCollapsibleCard heading="Create On Course Score">
                                    <div className="row"> 
                                        <div className="col-sm-12 col-lg-3"> 
                                                <Label for="Select">Student *</Label>
                                                <FormGroup>    
                                                    <Label for="Select">Student *</Label>                                                
                                                    <Selectsearch id="student" name="student" options={allstudent}  rules={{ required: 'Please select an student'}} value={stdrole==1? allstudent[0] : allstudent.find(obj => obj.value === this.state.student)} onChange={this.selstudent} required/>
                                                    {this.state.errors.student && <span className="text-danger">{this.state.errors.student}</span>}
                                                </FormGroup>
                                        </div> 
                                        
                                        <div className="col-sm-12 col-lg-3">
                                            <FormGroup>
                                                <Label for="date">Date *</Label>
                                                <DatePicker className="form-control" id="seldate"  name="seldate" autoComplete="off" required
                                                        selected={this.state.seldate}
                                                        onChange={this.selectdate}  
                                                        dateFormat='yyyy-MM-dd'
                                                        selectsEnd
                                                        maxDate={new Date()}   
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"                                               
                                                    /> 
                                            </FormGroup>                                          
                                        </div> 
                                        <div className="col-sm-12 col-lg-3"> 
                                                <Label for="course">Course *</Label>
                                                <FormGroup>
                                                    <Label for="course">Course *</Label>
                                                    <Selectsearch placeholder="Select the course" id="course" name="course" rules={{ required: 'Please select course'}} options={allclub} value={allclub.find(obj => obj.value === this.state.club)} onChange={this.selclub} required/>
                                                    {this.state.errors.club && <span className="text-danger">{this.state.errors.club}</span>}
                                                </FormGroup>
                                        </div>
                                         
                                        <div className="col-sm-12 col-lg-12"> 
                                            <div className="form-group">
                                                <div className="table-responsive">
                                                    <Table>
                                                        <TableHead>
                                                            <TableRow hover>   
                                                                <TableCell align="center" width={'10%'}>HOLE PAR</TableCell>
                                                                <TableCell align="center" width={'15%'}>F.W HIT</TableCell>
                                                                <TableCell align="center" width={'10%'}>APPROACH DISTANCE (YDS)</TableCell>
                                                                <TableCell align="center" width={'15%'}>GIR HIT</TableCell>
                                                                <TableCell align="center" width={'10%'}>PUTT LENGTH (FT)</TableCell>
                                                                <TableCell align="center" width={'10%'}># OF PUTTS</TableCell>
                                                                <TableCell align="center" width={'10%'}>PENALTIES</TableCell>
                                                                <TableCell align="center" width={'10%'}>SCORE</TableCell>
                                                                <TableCell align="center" width={'10%'}>PROCESS</TableCell>
                                                                <TableCell align="center" width={'10%'}>DELETE</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>

                                                        {this.state.formValues.map((element, i) => (
                                                             
                                                            <TableRow key={i}>
                                                            <TableCell>
                                                                <select  name="holepar" id={"holepar_"+i}  className="form-control form-control-alternative" 
                                                                value={element.holepar || ""} onChange={e => this.handleChange(i, e)} required>
                                                                    <option value=""> </option>
                                                                    <option value="3">PAR 3</option>
                                                                    <option value="4">PAR 4</option>
                                                                    <option value="5">PAR 5</option>                                            
                                                                </select>
                                                            </TableCell>
                                                            <TableCell>
                                                                <select  name="fwhit" id={"fwhit_"+i} disabled={this.state.editable['fwhit_'+i] }  className="form-control form-control-alternative" 
                                                                value={element.fwhit || ""} onChange={e => this.handleChange(i, e)}>
                                                                    <option value=""> </option>
                                                                    <option value="1">YES</option>
                                                                    <option value="2">MISS RIGHT</option>
                                                                    <option value="3">MISS LEFT</option>                                            
                                                                </select>
                                                            </TableCell> 
                                                            <TableCell>
                                                                <select  name="distance" id={"distance_"+i}  className="form-control form-control-alternative" 
                                                                value={element.distance || ""} onChange={e => this.handleChange(i, e)} required>
                                                                    <option value=""> </option>
                                                                    <option value="0-30">0-30</option>
                                                                    <option value="31-50">31-50</option>
                                                                    <option value="51-80">51-80</option>
                                                                    <option value="81-100">81-100</option>
                                                                    <option value="101-120">101-120</option>
                                                                    <option value="121-140">121-140</option>                                            
                                                                    <option value="141-160">141-160</option>
                                                                    <option value="161-180">161-180</option>
                                                                    <option value="181-200">181-200</option>
                                                                    <option value="201-220">201-220</option>
                                                                </select>
                                                            </TableCell> 
                                                            <TableCell>
                                                                <select  name="girhit" id={"girhit_"+i}  className="form-control form-control-alternative" 
                                                                value={element.girhit || ""} onChange={e => this.handleChange(i, e)} required>
                                                                    <option value=""> </option>
                                                                    <option value="1">YES</option>
                                                                    <option value="2">MISS RIGHT</option>
                                                                    <option value="3">MISS LEFT</option> 
                                                                    <option value="4">MISS SHORT</option> 
                                                                    <option value="5">MISS LONG</option>
                                                                    <option value="6">MISS LONG RIGHT</option> 
                                                                    <option value="7">MISS LONG LEFT</option>     
                                                                    <option value="8">MISS SHORT RIGHT</option>  
                                                                    <option value="9">MISS SHORT LEFT</option>                                            
                                                                </select>
                                                            </TableCell>    
                                                            <TableCell><input type="text" name={'puttlength'} id={'puttlength_'+i} value={element.puttlength || ""} onKeyPress={e => this.handleNumberic(e)}  onChange={e => this.handleChange(i, e)} className="form-control form-control-alternative" required/></TableCell>
                                                            <TableCell><input type="text" name={'noputt'} id={'noputt_'+i} value={element.noputt || ""} onKeyPress={e => this.handleNumberic(e)}  onChange={e => this.handleChange(i, e)} className="form-control form-control-alternative" required/></TableCell>
                                                            <TableCell>
                                                            <div onChange={e => this.handleChangeRadio(i, e, 1)} style={{textAlign:"center"}}>
                                                                <input type="radio" value="1" name={'ysnopenalties_'+i}  required/> Yes 
                                                                <input type="radio" value="0" name={'ysnopenalties_'+i} style={{marginLeft:"10px"}} /> No
                                                                <input type="hidden" value={element.penalties} name="penalties" id={'penalties_'+i} />
                                                            </div>
                                                            </TableCell>
                                                            <TableCell>
                                                                <select  name="score" id={"score_"+i}  className="form-control form-control-alternative" 
                                                                value={element.score || ""} onChange={e => this.handleChange(i, e)} required>
                                                                    <option value=""> </option>
                                                                    <option value="3">Worse than +2</option>
                                                                    <option value="2">+2</option>
                                                                    <option value="1">+1</option> 
                                                                    <option value="0">0</option> 
                                                                    <option value="-1">-1</option>    
                                                                    <option value="-2">-2</option>                                            
                                                                </select>
                                                            </TableCell>
                                                            <TableCell>
                                                            <div onChange={e => this.handleChangeRadio(i, e, 2)} style={{textAlign:"center"}}>
                                                                <input type="radio" value="1" name={'ysnoprocess_'+i}  required/> Yes 
                                                                <input type="radio" value="0" name={'ysnoprocess_'+i} style={{marginLeft:"10px"}} /> No
                                                                <input type="hidden" value={element.process} name="process" id={'process_'+i} />
                                                            </div>
                                                            </TableCell>
                                                            <TableCell>
                                                                {
                                                                    i ? 
                                                                    <IconButton style={{ width: "10px", height: "10px"}} className="text-danger" aria-label="Remove" onClick={() => this.removeFormFields(i)}  > <DeleteOutlineOutlinedIcon/></IconButton> 
                                                                        : null
                                                                }
                                                            </TableCell>
                                                            </TableRow>
                                                        ))}
                                                        </TableBody>
                                                    </Table>   
                                                </div>  
                                            </div>      
                                        </div>   
                                        <div className="col-lg-12">
                                            <div className="dd">
                                                <button  className="mr-3 mb-3 btn btn-outline-primary btn-sm float-right" type="button" onClick={() => this.addFormFields()}> <i class="zmdi zmdi-plus-circle-o"></i> add shot</button>
                                            </div>
                                        </div>                                     

                                       <div className="col-lg-12">
                                        <div className="form-group"> 
                                            <button type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Submit" disabled={this.state.loader}>Submit</button>
                                            <button type="button" className="mr-3 mb-3 btn btn-outline-warning" onClick={this.props.onClick} >Back</button>   
                                        </div>
                                       </div>
                                    </div>    
                            </RctCollapsibleCard>
                         </div>   
                        </div>
                      </form>
            </div>
            {this.state.loader &&
            <div className="col-lg-12">
                <ProgressLoader />
            </div>
            }
        </div>
              
    )
   
}
 
}

const mapStateToProps = ({ mostlyused}) => {
    const { studentlists, clublist, loading } = mostlyused;
    return { studentlists, clublist, loading };
   
}


export default connect(mapStateToProps, {
    allStudents,
    allClubs,
    addOCScoring,
})(AddItems);
